import { EnhancedReturnStatus } from './enhanced-return-status';
import { ReturnEntityStatus } from './return-entity-status';

/**
 * This map represents the relation between the status of a Request and the status of it's Entites (Return/Exchange/Purchase)
 *
 * Definitions:
 * Request: A singe record created by a merchant or a customer filling the items to be returned, exhcanged or new items being purchased via SRR.
 * Entity: The actual return/exchange/purchase record. The collection of entities creates the request.
 *
 * Example:
 * 1. Say, a request is in "PendingAtAdmin" status. This means that at least one of it's entities is in a status that requires admin action.
 *    In such case, the entities that require action from admin are those which are in status "AwaitingExchangeApproval" or "AwaitingRefundApproval" status and not others
 * 2. Say, a request is in "Processed" status. This means that all of it's entities are in a terminal status such as "ExchangeSuccess", "RefundRejected", etc. as mentioned below.
 */
export const EnhancedReturnsToEntityStatus = {
  [EnhancedReturnStatus.PendingCompletion.key]: [ReturnEntityStatus.AwaitingCompletion.key],
  [EnhancedReturnStatus.PendingDelivery.key]: [ReturnEntityStatus.AwaitingDelivery.key],
  [EnhancedReturnStatus.PendingAtAdmin.key]: [
    ReturnEntityStatus.AwaitingExchangeApproval.key,
    ReturnEntityStatus.AwaitingRefundApproval.key,
  ],
  [EnhancedReturnStatus.PendingAtWarehouse.key]: [ReturnEntityStatus.AwaitingWarehouseAuthorization.key],
  [EnhancedReturnStatus.PendingAtStore.key]: [ReturnEntityStatus.AwaitingStoreAuthorization.key],
  [EnhancedReturnStatus.PendingPaymentCompletion.key]: [ReturnEntityStatus.AwaitingPaymentCompletion.key],
  [EnhancedReturnStatus.Processed.key]: [
    ReturnEntityStatus.QualificationApprovalRejected.key,
    ReturnEntityStatus.StoreAuthorizationRejected.key,
    ReturnEntityStatus.WarehouseAuthorizationRejected.key,
    ReturnEntityStatus.ExchangeRejected.key,
    ReturnEntityStatus.RefundRejected.key,
    ReturnEntityStatus.ExchangeSuccess.key,
    ReturnEntityStatus.RefundSuccess.key,
  ],
  [EnhancedReturnStatus.Cancelled.key]: [ReturnEntityStatus.Cancelled.key],
};
